export function getUsers(state) {
	return state.app.users;
}

export function getLogs(state) {
	return state.app.logs;
}

